import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ProjectCard = makeShortcode("ProjectCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Projects`}</h2>
    <ProjectCard title="Jimmy&Ross" link="https://jimmy-ross.myshopify.com/password" bg="linear-gradient(to right, #D4145A 0%, #FBB03B 100%)" mdxType="ProjectCard">
Custom Built CRO Shopify Theme for a furniture store with customer loss tracking and sales logic implemented. Password: Jimmy&RossThemeWorx
    </ProjectCard>
    <ProjectCard title="The Tech Academy" link="https://thetechacademy.net/" bg="linear-gradient(to right, #D4145A 0%, #FBB03B 100%)" mdxType="ProjectCard">
This is the website for TTA, one of the leading educational consultancies in Bangladesh. Done on Wordpress
    </ProjectCard>
    <ProjectCard title="Raparaps" link="https://raparaps.fi/" bg="linear-gradient(to right, #D4145A 0%, #FBB03B 100%)" mdxType="ProjectCard">
This is a specialized shopify project with a high-converting Product landing page for an International Pet Lifestyle Company. 
    </ProjectCard>
    <ProjectCard title="BoxPack" link="https://boxpack.netlify.app/" bg="linear-gradient(to right, #D4145A 0%, #FBB03B 100%)" mdxType="ProjectCard">
Custom built ReactJS theme with Redux for data-layer logic for Sweedish Packaging Company.
    </ProjectCard>
    <ProjectCard title="Roar Retail" link="https://www.upwork.com/freelancers/~01cffcb82b510cfaef?p=1500559999073255424" bg="linear-gradient(to right, #D4145A 0%, #FBB03B 100%)" mdxType="ProjectCard">
Consumer Retail Clothing business case study for a leading brand
    </ProjectCard>
    <ProjectCard title="SeaGloryBD" link="https://www.upwork.com/freelancers/~01cffcb82b510cfaef?p=1380123075866132480" bg="linear-gradient(to right, #D4145A 0%, #FBB03B 100%)" mdxType="ProjectCard">
Case Study of a Build for one of my earliest clients
    </ProjectCard>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      